// TAG Heuer Carrera landing — page UI + lead funnel.
// UI: scroll reveal, gallery, lightbox, sticky dock, smooth anchors.
// Funnel: validasi form, simpan ke Google Sheet (Apps Script / app proxy),
// lalu buka WhatsApp. Event pgj:* diteruskan ke Meta Pixel / GTM lewat
// store analytics (tanpa PII di payload).
(() => {
  "use strict";

  const root = document.querySelector(".pgj-carrera.landing-root") || document.querySelector(".pgj-carrera");
  if (!root) return;

  const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const q = (selector, scope = root) => scope.querySelector(selector);
  const qa = (selector, scope = root) => [...scope.querySelectorAll(selector)];

  // Reveal on scroll. Without IO or with reduced motion, content stays visible.
  if ("IntersectionObserver" in window && !motion.matches) {
    const reveal = qa("[data-reveal]");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("pgj-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -20px 0px" });

    root.classList.add("pgj-motion");
    reveal.forEach((element) => observer.observe(element));
  }

  // Keep the sticky section nav directly below the (fixed) theme header.
  const themeHeader = document.querySelector(".shopify-section-header");
  const syncHeaderOffset = () => {
    if (!themeHeader) {
      root.style.setProperty("--pgj-header-offset", "0px");
      return;
    }
    const fixed = themeHeader.classList.contains("fixed") ||
      getComputedStyle(themeHeader).position === "fixed";
    const height = fixed ? Math.round(themeHeader.getBoundingClientRect().height) : 0;
    root.style.setProperty("--pgj-header-offset", `${height}px`);
  };
  syncHeaderOffset();
  window.addEventListener("scroll", syncHeaderOffset, { passive: true });
  window.addEventListener("resize", syncHeaderOffset);

  // Gallery: thumbnails swap the main image.
  const galleryImage = q("[data-gallery-image]");
  if (galleryImage) {
    qa("[data-gallery-key]").forEach((button) => {
      button.addEventListener("click", () => {
        galleryImage.src = button.dataset.gallerySrc;
        galleryImage.alt = button.dataset.galleryAlt || "";
        qa("[data-gallery-key]").forEach((item) => {
          item.setAttribute("aria-pressed", String(item === button));
        });
      });
    });
  }

  // Lightbox: used by the main stage and the lookbook grid.
  const lightbox = q("[data-lightbox]");
  const lightboxImage = q("[data-lightbox-image]");
  const openLightbox = (src, alt) => {
    if (!lightbox || !src || typeof lightbox.showModal !== "function") return;
    lightboxImage.src = src;
    lightboxImage.alt = alt || "";
    lightbox.showModal();
    document.body.style.overflow = "hidden";
  };

  if (lightbox) {
    lightbox.addEventListener("close", () => {
      document.body.style.overflow = "";
      lightboxImage.removeAttribute("src");
    });
  }

  qa("[data-close]").forEach((button) => {
    button.addEventListener("click", () => button.closest("dialog")?.close());
  });

  q("[data-zoom]")?.addEventListener("click", () => {
    const stage = q("[data-zoom] img");
    if (stage) openLightbox(stage.currentSrc || stage.src, stage.alt);
  });

  qa("[data-lightbox-open]").forEach((button) => {
    button.addEventListener("click", () => {
      const inner = q("img", button);
      openLightbox(button.dataset.lightboxOpen || inner?.currentSrc || inner?.src, button.dataset.lightboxAlt || inner?.alt);
    });
  });

  // Sticky dock: visible after the hero, hidden while the purchase panel is on screen.
  const dock = q("[data-dock]");
  const hero = q(".pgj-hero");
  const purchase = q("#pgj-purchase");

  if (dock && "IntersectionObserver" in window && hero && purchase) {
    let heroVisible = true;
    let purchaseVisible = false;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === purchase) purchaseVisible = entry.isIntersecting;
      });
      dock.hidden = heroVisible || purchaseVisible;
    }, { threshold: 0 });

    observer.observe(hero);
    observer.observe(purchase);
  } else if (dock) {
    dock.hidden = false;
  }

  // Smooth in-page navigation. Dialog triggers are left to the lead funnel.
  root.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href^="#"]');
    if (!link || !root.contains(link)) return;

    const id = link.getAttribute("href").slice(1);
    if (!id) return;

    const target = document.getElementById(id);
    if (!target || target.tagName === "DIALOG") return;

    event.preventDefault();
    target.scrollIntoView({ behavior: motion.matches ? "auto" : "smooth", block: "start" });

    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
    target.focus({ preventScroll: true });
  });
})();

// ponytail: page-scoped lead state; cross-device deduplication belongs to the API.
(function () {
  const dialog = document.getElementById('pgj-consultation');
  if (!dialog) return;
  const form = dialog.querySelector('form');
  const fields = form.elements;
  const status = dialog.querySelector('[data-lead-status]');
  const next = dialog.querySelector('[data-lead-continue]');
  const resetBtn = dialog.querySelector('[data-lead-reset]');
  const submit = form.querySelector('[type=submit]');
  const config = dialog.dataset;
  const endpoint = config.endpoint;
  // UTM-based WA routing: halaman sama, nomor beda.
  // External (default) = data-whatsapp, mis. 6285880170977.
  // Internal = data-whatsapp-internal, mis. 6282298616979, aktif saat
  // utm_campaign / utm_source / utm_content mengandung trigger (default: "internal").
  // Contoh internal: ?utm_campaign=carrera-internal
  function pickWhatsapp() {
    try {
      const params = new URLSearchParams(location.search || '');
      const triggers = String(config.whatsappTrigger || 'internal').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
      if (!triggers.length) return config.whatsapp;
      const haystack = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].map(k => (params.get(k) || '').toLowerCase());
      const isInternal = haystack.some(value => triggers.some(trigger => value.includes(trigger)));
      if (isInternal && /^[1-9]\d{7,14}$/.test(config.whatsappInternal || '')) return config.whatsappInternal;
    } catch (_) { /* URL parsing must not block consultation. */ }
    return config.whatsapp;
  }
  config.whatsapp = pickWhatsapp();
  // Apps Script /exec diizinkan sebagai penyimpanan sementara; naik ke app proxy /apps/ + CAPI saat production.
  let crossOrigin = false;
  const endpointValid = (() => {
    if (/^\/apps\/[a-zA-Z0-9/_-]+$/.test(endpoint)) return true;
    try {
      const url = new URL(endpoint);
      crossOrigin = true;
      return url.protocol === 'https:' && url.hostname === 'script.google.com' && url.pathname.endsWith('/exec');
    } catch (_) { return false; }
  })();
  const ready = endpointValid && /^[1-9]\d{7,14}$/.test(config.whatsapp) && !!config.variantId;
  let requestId;
  let saved;
  let contactSent = false;
  let opener;
  let viewSent = false;
  const marketingAllowed = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const eventData = () => ({
    product_id: config.productId, variant_id: config.variantId, sku: config.sku,
    content_ids: [config.variantId], content_type: 'product',
    content_name: config.productTitle, value: Number(config.value), currency: config.currency
  });
  function publish(name, extra = {}) {
    // Store events selalu dikirim (payload bebas PII). Gating consent untuk
    // pengiriman Meta ada di Custom Pixel subscriber (browser) dan CAPI (server).
    try {
      const pending = window.Shopify?.analytics?.publish?.(name, { ...eventData(), ...extra });
      pending?.catch?.(() => {});
    } catch (_) { /* Tracking failure must not block consultation. */ }
  }
  function directFbq(name, params, eventID) {
    // Direct browser event pada pixel Meta yang sudah dimuat (tanpa init / ID hardcode).
    try {
      if (typeof fbq === 'function') fbq('track', name, params, { eventID });
    } catch (_) { /* Pixel failure must not block consultation. */ }
  }
  function dataLayerPush(name, params, eventId) {
    // Path GTM: dorong dataLayer agar tag GTM memakai Custom Event trigger pgj_*.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params, event_id: eventId });
    } catch (_) { /* Tracking failure must not block consultation. */ }
  }
  let viewEventId = '';
  let viewPublished = false;
  function viewContent() {
    // ViewContent = pengunjung engage sampai CTA akhir (section commerce), bukan PageView.
    if (viewSent || !config.variantId) return;
    try { viewEventId = 'pgj_view_' + crypto.randomUUID(); } catch (_) { viewEventId = 'pgj_view_' + Date.now(); }
    viewSent = true;
    const params = { ...eventData() };
    viewPublished = publishView();
    dataLayerPush('pgj_view_content', params, viewEventId);
    directFbq('ViewContent', params, viewEventId);
  }
  function publishView() {
    if (!viewSent || viewPublished || !viewEventId || !window.Shopify?.analytics?.publish) return viewPublished;
    publish('pgj:product_viewed', { event_id: viewEventId });
    return true;
  }
  function observeEngagement() {
    let target = null;
    try { target = document.getElementById('pgj-purchase'); } catch (_) { target = null; }
    if (!target || typeof IntersectionObserver !== 'function') { viewContent(); return; }
    try {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          try { observer.disconnect(); } catch (_) {}
          viewContent();
        }
      }, { threshold: 0.2 });
      observer.observe(target);
    } catch (_) { viewContent(); }
  }
  observeEngagement();
  // Retry kaki subscriber bila API Shopify belum siap saat engagement terjadi.
  document.addEventListener('visitorConsentCollected', publishView);
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (!error) publishView();
  });
  submit.disabled = !ready;
  if (ready) status.textContent = '';
  // Commerce (AddToCart / InitiateCheckout / Purchase) ditangani oleh integrasi
  // resmi Shopify (web pixel / Facebook & Instagram) melalui form native di
  // bawah. Landing TIDAK mengirim event commerce sendiri supaya AddToCart tidak
  // terkirim dua kali di Meta/GTM.
  document.querySelectorAll('.pgj-carrera.landing-root a[href="#pgj-consultation"]').forEach(link => {
    link.removeAttribute('target');
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', dialog.id);
    link.addEventListener('click', event => {
      event.preventDefault();
      opener = link;
      if (saved && next.href) {
        // Lead sudah tersimpan di page load ini: langsung buka WA lagi,
        // tetap tampilkan dialog sebagai fallback bila popup diblokir.
        if (!contactSent) {
          contactSent = true;
          publish('pgj:whatsapp_clicked', { event_id: saved.event_id + '_contact', lead_id: saved.lead_id });
          dataLayerPush('pgj_contact', { ...eventData(), lead_id: saved.lead_id }, saved.event_id + '_contact');
        }
        beaconWaClick(saved.request_id);
        window.open(next.href, '_blank', 'noopener');
        dialog.showModal();
        return;
      }
      if (!saved) {
        const purpose = link.dataset.purpose || (link.closest('#pgj-showroom') ? 'Booking showroom' : '');
        if (purpose && fields.purpose) fields.purpose.value = purpose;
      }
      dialog.showModal();
    });
  });
  dialog.querySelector('[data-lead-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus());
  fields.phone.addEventListener('input', () => fields.phone.setCustomValidity(''));
  function attribution() {
    // UTM/referrer/fbclid = data URL first-party, dikirim tanpa menunggu consent cookie; _fbp/_fbc tetap di-gate.
    const result = { landing_url: location.href, wa_destination: String(config.whatsapp || '').slice(0, 20) };
    const params = new URLSearchParams(location.search);
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid']) {
      result[key] = (params.get(key) || '').slice(0, 500);
    }
    if (marketingAllowed()) {
      for (const key of ['_fbp', '_fbc']) {
        result[key] = (document.cookie.split('; ').find(cookie => cookie.startsWith(key + '='))?.slice(key.length + 1) || '').slice(0, 500);
      }
    }
    try { result.referrer = document.referrer ? new URL(document.referrer).origin : ''; } catch (_) { result.referrer = ''; }
    return result;
  }
  function beaconWaClick(requestId) {
    // Catat wa_clicked_at di sheet lewat GET beacon; gagal diam saja.
    try { fetch(endpoint + '?wa_click=' + encodeURIComponent(requestId), { credentials: 'omit' }).catch(() => {}); } catch (_) {}
  }
  next.addEventListener('click', () => {
    if (!saved) return;
    // Publish Contact sekali (dedupe Meta via event_id sama), beacon boleh tiap klik
    // agar wa_clicked_at tercatat walau user buka WA berkali-kali.
    if (!contactSent) {
      contactSent = true;
      publish('pgj:whatsapp_clicked', { event_id: saved.event_id + '_contact', lead_id: saved.lead_id });
      dataLayerPush('pgj_contact', { ...eventData(), lead_id: saved.lead_id }, saved.event_id + '_contact');
    }
    beaconWaClick(saved.request_id);
  });
  resetBtn?.addEventListener('click', () => {
    // Mulai lead baru di halaman yang sama tanpa reload.
    saved = undefined;
    requestId = undefined;
    contactSent = false;
    form.reset?.();
    form.hidden = false;
    next.hidden = true;
    next.removeAttribute('href');
    if (resetBtn) resetBtn.hidden = true;
    form.querySelector('fieldset').disabled = false;
    submit.disabled = !ready;
    status.textContent = '';
    form.querySelector('input[name=name]')?.focus?.();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!ready || saved || submit.disabled) return;
    fields.name.value = fields.name.value.trim();
    fields.city.value = fields.city.value.trim();
    for (const field of [fields.name, fields.city]) {
      field.setCustomValidity(field.value.length >= 2 ? '' : 'Isi minimal 2 karakter.');
      field.oninput = () => field.setCustomValidity('');
    }
    const raw = fields.phone.value.trim();
    let phone = raw.replace(/[\s()-]/g, '');
    if (phone.startsWith('08')) phone = '+62' + phone.slice(1);
    else if (phone.startsWith('62')) phone = '+' + phone;
    fields.phone.setCustomValidity(/^[+\d\s()-]+$/.test(raw) && /^\+[1-9]\d{7,14}$/.test(phone) ? '' : 'Masukkan nomor WhatsApp valid dengan kode negara.');
    if (!form.reportValidity()) return;
    requestId ||= crypto.randomUUID();
    const payload = {
      request_id: requestId,
      name: fields.name.value, phone, city: fields.city.value,
      purpose: fields.purpose.value, contact_time: fields.contact_time.value.trim(),
      consent: { contact: fields.consent.checked, marketing: marketingAllowed(), policy_version: 'pgj-consultation-v1' },
      product: { id: config.productId, variant_id: config.variantId, handle: config.productHandle, sku: config.sku, title: config.productTitle, value: Number(config.value), currency: config.currency },
      attribution: attribution()
    };
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    form.querySelector('fieldset').disabled = true;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = 'Menyimpan permintaan…';
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: crossOrigin ? 'omit' : 'same-origin',
        redirect: crossOrigin ? 'follow' : 'error',
        // Apps Script menolak preflight: jangan kirim header custom, pakai text/plain agar jadi simple request.
        headers: crossOrigin ? { 'Content-Type': 'text/plain;charset=utf-8' } : { 'Content-Type': 'application/json', Accept: 'application/json', 'Idempotency-Key': requestId },
        body: JSON.stringify(payload), signal: controller.signal
      });
      if (!response.ok) throw new Error('save_failed');
      const result = await response.json();
      if (result.status !== 'saved' || result.request_id !== requestId ||
          !/^[A-Za-z0-9_-]{1,100}$/.test(result.lead_id || '') ||
          !/^[A-Za-z0-9_-]{1,120}$/.test(result.event_id || '')) throw new Error('invalid_receipt');
      saved = result;
      const message = `Halo PGJ Watches, saya ${payload.name} dari ${payload.city}. Saya tertarik dengan ${config.productTitle} (${config.sku}) dan ingin ${payload.purpose.toLowerCase()}. Nomor WhatsApp: ${phone}.${payload.contact_time ? ' Waktu dihubungi: ' + payload.contact_time + '.' : ''} Lead ID: ${result.lead_id}.`;
      next.href = 'https://wa.me/' + config.whatsapp + '?text=' + encodeURIComponent(message);
      // Lead fires only after successful “Simpan & lanjutkan”; CTA open and WA click are not Lead.
      publish('pgj:lead_form_submitted', { event_id: result.event_id, lead_id: result.lead_id });
      dataLayerPush('pgj_lead', { ...eventData(), lead_id: result.lead_id }, result.event_id);
      directFbq('Lead', {
        content_name: config.productTitle, content_ids: [config.variantId],
        content_type: 'product', value: Number(config.value), currency: config.currency
      }, result.event_id);
      status.textContent = 'Permintaan Anda tersimpan. Klik tombol di bawah untuk membuka WhatsApp, lalu kirim pesan kepada advisor.';
      form.hidden = true;
      next.hidden = false;
      if (resetBtn) resetBtn.hidden = false;
      next.focus();
    } catch (_) {
      status.textContent = 'Permintaan belum tersimpan. Silakan coba lagi.';
    } finally {
      clearTimeout(timeout);
      form.removeAttribute('aria-busy');
      form.querySelector('fieldset').disabled = !!saved;
      submit.disabled = !!saved;
    }
  });
})();
